let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2g2fD")).then(() => parcelRequire('5D0rE'));